export const NAME = 'Page View Trigger';

export const ID = '03da3889-5cb8-4b57-9ad9-8ad962e54fee';
